import {
  QUERY_RESPONSE_RECEIVED,
  MUTATION_RESPONSE_RECEIVED,
} from '@web-platform/shared-universal-constants/src/network';
import {
  SONAR_V3_ALPHA_CREATE_SESSION,
  SONAR_V3_CREATE_SESSION,
  SONAR_V3_POLL,
  SONAR_V3_POLL_ALPHA,
} from '@web-platform/shared-universal-types/src/network/requestTypes';
import { isSonarV3ErrorPayload } from '@web-platform/shared-universal-utils-frontend/src/helpers/isSonarErrorPayload';

import { mapAgentsFromSonarV3Response } from './sonarV3AgentsMapper';

import type {
  MutationAction,
  MutationResponseAction,
  QueryAction,
  QueryResponseAction,
} from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type {
  AgentStateBookingPanel,
  AgentsBookingPanel,
} from '@web-platform/shared-universal-types/src/redux/state/shared/flightBookingPanel/entities/agentsBookingPanel';

export const INITIAL_STATE: AgentStateBookingPanel = {
  byId: {},
};

const byId = (state: AgentsBookingPanel, action: MutationResponseAction | QueryResponseAction) => {
  if (
    action.payload.type === SONAR_V3_CREATE_SESSION ||
    action.payload.type === SONAR_V3_ALPHA_CREATE_SESSION ||
    action.payload.type === SONAR_V3_POLL ||
    action.payload.type === SONAR_V3_POLL_ALPHA
  ) {
    if (isSonarV3ErrorPayload(action.payload.response)) {
      return state;
    }
    const updatedAgents = mapAgentsFromSonarV3Response(state, action.payload.response.body);
    return { ...state, ...updatedAgents };
  }

  return state;
};

const agentsReducer = (
  state: AgentStateBookingPanel = INITIAL_STATE,
  action: MutationAction | QueryAction,
): AgentStateBookingPanel => {
  switch (action.type) {
    case MUTATION_RESPONSE_RECEIVED:
    case QUERY_RESPONSE_RECEIVED: {
      const newById = byId(state.byId, action);
      if (newById === state.byId) return state;
      return { byId: newById };
    }

    default:
      return state;
  }
};

export default agentsReducer;
